export default "__VITE_ASSET__Eax2ifel__"